import React from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  const categories = [
    { id: 1, title: 'Weddings', span: 'row-span-2', src: '/Weddings/wedding cover.JPG', slug: 'weddings' },
    { id: 2, title: 'Portraits', span: '', src: '/Portrait/IMG_4114.jpg', slug: 'portraits' },
    { id: 3, title: 'Live Performance', span: '', src: '/Live performance/IMG_0054.jpg', slug: 'live-performance' },
  ];

  // All categories archived - add them back one by one as instructed
  // { id: 2, title: 'Portraits', span: '', src: '/IMG_4114.jpg', slug: 'portraits' },
  // { id: 3, title: 'Events', span: '', src: '/IMG_2319.jpg', slug: 'events' },
  // { id: 4, title: 'Live Performance', span: '', src: '/IMG_6272.JPG', slug: 'live-performance' },
  // { id: 5, title: 'Proposal Day', span: 'row-span-2', src: '/IMG_1703.jpg', slug: 'proposal-day' },
  // { id: 6, title: 'Engagement', span: '', src: '/IMG_1833.jpg', slug: 'engagement' },
  // { id: 7, title: 'Graduation Day', span: '', src: '/IMG_5367.jpg', slug: 'graduation-day' },
  // { id: 8, title: 'Shows', span: '', src: '/IMG_7456.JPG', slug: 'shows' },
  // { id: 9, title: 'Candid Moments', span: '', src: '/IMG_9500.JPG', slug: 'candid-moments' },
  // { id: 10, title: 'The Crew', span: '', src: '/JCCM4630.jpg', slug: 'the-crew' },

  return (
    <section id="portfolio" className="py-12 md:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <span className="text-forest font-semibold text-sm tracking-widest uppercase">Portfolio</span>
            <div className="h-1 w-16 bg-forest mt-2 mx-auto"></div>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-4">
            Captured Moments
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            A glimpse into the stories we've told through our lens
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 auto-rows-[350px] max-w-5xl mx-auto">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/gallery/${category.slug}`}
              className={`group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer ${category.span}`}
            >
              <div className="absolute inset-0 w-full h-full">
                <img 
                  src={category.src} 
                  alt={category.title}
                  width="800"
                  height="600"
                  className="w-full h-full object-cover transform scale-100 group-hover:scale-110 transition-transform duration-700"
                  style={{ 
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/30 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500"></div>
              <div className="absolute inset-0 flex items-end p-6">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="text-white text-2xl md:text-3xl font-serif font-semibold drop-shadow-lg block">{category.title}</span>
                  <div className="h-1 w-0 group-hover:w-16 bg-accent mt-2 transition-all duration-500"></div>
                </div>
              </div>
              {/* View Icon */}
              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="bg-white/20 backdrop-blur-sm rounded-full p-2">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* See More CTA */}
        <div className="text-center mt-12">
          <Link
            to="/galleries"
            className="inline-block bg-forest text-white font-bold px-12 py-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 hover:bg-secondary"
          >
            <span className="flex items-center gap-2">
              View Full Portfolio
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
